var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-time_card",
    d: "M9.4,4A1.809,1.809,0,0,0,7.6,5.8V8.486A2.211,2.211,0,0,0,6,10.6v7.2A2.209,2.209,0,0,0,8.2,20h9.6A2.209,2.209,0,0,0,20,17.8V10.6a2.211,2.211,0,0,0-1.6-2.114V7a.6.6,0,0,0-.176-.424l-2.4-2.4A.6.6,0,0,0,15.4,4Zm0,1.2h5.752L17.2,7.248V8.4H8.8V5.8A.591.591,0,0,1,9.4,5.2ZM8.2,9.6h9.6a.991.991,0,0,1,1,1v7.2a.991.991,0,0,1-1,1H8.2a.991.991,0,0,1-1-1V10.6A.991.991,0,0,1,8.2,9.6ZM13,10.8a3.4,3.4,0,1,0,3.4,3.4A3.4,3.4,0,0,0,13,10.8ZM12.8,12a.4.4,0,0,1,.4.4V14h1.2a.4.4,0,1,1,0,.8H12.8a.4.4,0,0,1-.4-.4v-2A.4.4,0,0,1,12.8,12Z",
    transform: "translate(-6 -4)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeCard);
export default __webpack_public_path__ + "static/media/time_card.64f0c6e11eee767d45566fb138e9d0f4.svg";
export { ForwardRef as ReactComponent };